import {
  EMAIL_RX,
  PHONE_RX,
  CITY_STATE_ZIP_RX,
  STREET_RX,
} from "./docRegexUtils";


export function parseContactBlock(block = "") {
  const lines = block
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean);

  let name = "";
  let org = "";
  let street = "";
  let city = "";
  let state = "";
  let zip = "";
  let email = "";
  let phone = "";

  // Pass 1: scan for email and phone anywhere
  for (const l of lines) {
    if (!email && EMAIL_RX.test(l)) {
      email = (l.match(EMAIL_RX) || [])[0] || "";
    }
    if (!phone && PHONE_RX.test(l)) {
      phone = (l.match(PHONE_RX) || [])[0] || "";
    }
  }

  // Pass 2: scan for city/state/zip line
  let cszIdx = -1;
  for (let i = lines.length - 1; i >= 0; i--) {
    const m = lines[i].match(CITY_STATE_ZIP_RX);
    if (m) {
      cszIdx = i;
      city = m[1].trim();
      state = m[2].toUpperCase();
      zip = m[3];
      break;
    }
  }

  // Pass 3: street line (before CSZ if found, otherwise best guess)
  let streetIdx = -1;
  const searchEnd = cszIdx > 0 ? cszIdx - 1 : lines.length - 1;
  for (let i = searchEnd; i >= 0; i--) {
    if (STREET_RX.test(lines[i])) {
      streetIdx = i;
      street = lines[i];
      break;
    }
  }

  // Pass 4: guess name/org from top non-empty lines
  const candidateTop = lines.filter(
    (l) =>
      l !== street &&
      l !== `${city}, ${state} ${zip}` &&
      !EMAIL_RX.test(l) &&
      !PHONE_RX.test(l)
  );

  if (candidateTop.length) {
    name = candidateTop[0];
    if (candidateTop.length > 1) {
      org = candidateTop[1];
    }
  }

  return {
    raw: block,
    name,
    org,
    street,
    city,
    state,
    zip,
    phone,
    email,
  };
}


export const parseRecipientBlock = (text) => parseContactBlock(text);
export const parseSenderBlock = (text) => parseContactBlock(text);


